
const setWatermark = (str1) => {
  const id = '1.23452384164.123412415'
  // 查看页面上有没有，如果有则删除
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }
  // 创建canvas元素(先制作一块背景图)
  const can = document.createElement('canvas')
  can.width = 188
  can.height = 120
  const cans = can.getContext('2d')
  cans.rotate(-20 * Math.PI / 180)
  cans.font = '14px Vedana'
  cans.fillStyle = 'rgba(230, 230, 230, 0.7)'
  cans.textAlign = 'center'
  cans.textBaseline = 'Middle'
  cans.fillText(str1, can.width / 2.8, can.height)
  const div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '0px'
  div.style.left = '-10px'
  // div.style.opacity = '0.15'
  div.style.position = 'fixed'
  div.style.zIndex = '2'
  div.style.width = document.documentElement.clientWidth + 'px'
  div.style.height = document.documentElement.clientHeight + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}
// 添加水印
export const setWaterMark = (str1) => {
  setWatermark(str1)
}
// 移除水印
export const removeWatermark = () => {
  const idx = '1.23452384164.123412415'
  if (document.getElementById(idx) !== null) {
    document.body.removeChild(document.getElementById(idx))
  }
}




// WEBPACK FOOTER //
// ./src/pages/motor/watermark.js